<div [formGroup]="frmGroup">
  <div
    *ngFor="let item of InputConfig?.radioCofig?.radioGroup"
    [class]="item.style"
  >
    <!-- <hcc-custom-validation [validations]="fieldInfo.validations"> -->
    <!-- </hcc-custom-validation> -->
    <label *ngIf="fieldInfo.showLabel" class="cursor-pointer">
      <input
        *ngIf="InputConfig?.isDisabled"
        type="radio"
        [name]="control"
        [value]="item.value"
        class="m-1 mr-0"
        [formGroup]="frmGroup"
        acRadiobutton
        (change)="OnRadioChange(item.label)"
        [formControlName]="control"
        [fieldInfo]="fieldInfo"
        [checked]="item.checked"
        disabled
      />

      <input
        *ngIf="!InputConfig?.isDisabled"
        type="radio"
        [name]="control"
        [value]="item.value"
        class="m-1 mr-0"
        [formGroup]="frmGroup"
        acRadiobutton
        (change)="OnRadioChange(item.label)"
        [formControlName]="control"
        [fieldInfo]="fieldInfo"
        [checked]="item.checked"
      />
      {{ item.label
      }}<span
        class="required-star"
        *ngIf="fieldInfo.required && fieldInfo.label"
        >*</span
      >
    </label>
  </div>
</div>
